.main {
	display: flex;
	flex-direction: column;
	gap: var(--size-8);
	width: 100%;
	height: 100%;
}

.menu {
	display: flex;
	align-items: center;
	gap: var(--size-3);

	&[data-visible="false"] {
		display: none;
	}
}

.body {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: auto;
	gap: var(--size-3);
}

.tableCard {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
}

.search {
	display: flex;
	align-items: stretch;
	gap: var(--size-3);

	> input {
		flex: 1;
		min-width: 0;
	}
}

.withDesc {
	width: 100%;
	display: flex;
	flex-direction: column;
	font-weight: 500;

	.desc {
		font-weight: normal;
		font-size: var(--text-caption);
		color: var(--color-text-subtle);
	}
}

.chip {
	position: relative;
	z-index: 2;
	max-width: 100%;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	display: inline-flex;
	align-items: center;
	gap: var(--size-3);
	padding: var(--size-1) var(--size-3);
	font-size: var(--text-caption);
	font-weight: 500;
	border-radius: var(--radius-sm);
	background: light-dark(var(--gray-300), var(--gray-700));
	color: var(--color-text);

	button& {
		font-family: inherit;
		border: 0;
		cursor: pointer;
	}

	a&,
	button&:not(:disabled, [aria-disabled="true"]) {
		&:where(:hover, :focus-visible) {
			color: var(--gray-400);
			background: var(--color-primary);
			text-decoration: none;
		}
	}
}

.modal {
	display: flex;
	flex-direction: column;
	gap: var(--size-6);

	.error {
		color: var(--color-error-text);
		font-size: var(--text-caption);

		&:empty {
			display: none;
		}
	}

	.actions {
		justify-content: flex-end;
	}
}

.actions {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.centered {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: var(--size-9);
	gap: var(--size-9);
	a {
		width: 100%;
		max-width: 50rem;
		display: inline-flex;
		align-items: center;
		font-weight: 500;
		gap: var(--size-3);
	}
}
